// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WC6fBZ3Z4IYlvP {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: 0 6px;
  flex-grow: 1;
  height: 100%;
}
.WC6fBZ3Z4IYlvP[hidden] {
  display: none;
}
@media print {
  .WC6fBZ3Z4IYlvP {
    display: none;
  }
}
.CSwccJ0PrMROzz {
  justify-content: flex-start;
  width: 272px;
  padding: 12px;
  border-radius: 12px;
  background-color: #ffffff3d;
}
.s9FAIKkCVKnZTD {
  background-color: #ffffff3d;
  color: var(--dynamic-text);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addListButtonContainer": `WC6fBZ3Z4IYlvP`,
	"addListButton": `CSwccJ0PrMROzz`,
	"limitMessage": `s9FAIKkCVKnZTD`
};
export default ___CSS_LOADER_EXPORT___;
